import { CircularProgress } from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { setErrorMessage } from '../../../../../shared/helpers/functionalities';

const DescuentosMasivosForm = ({
    discount,
    updateDiscount,
    createDiscount,
    handleCancel,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const {
        register,
        formState: { errors },
        handleSubmit,
    } = useForm({
        defaultValues: {
            id: discount?.id || null,
            codigo: discount?.codigo || '',
            descuento: discount?.descuento || '',
            caducidad: discount?.caducidad || '',
            uso_limitado: discount?.uso_limitado || false,
            subject: discount?.subject || '',
            texto: discount?.texto || '',
            importe_maximo: discount?.importe_maximo || '',
        },
    });

    const onSubmit = async (data) => {
        try {
            setIsLoading(true);
            if (data?.id) {
                await updateDiscount(data);
            } else {
                await createDiscount(data);
            }
            handleCancel();
        } catch (error) {
            toast.error(setErrorMessage(error));
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="descuentos-masivos-form">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div
                    className="form-check d-flex align-items-center gap-2 mb-2"
                    style={{ paddingLeft: '0' }}
                >
                    <input
                        id="uso_limitado"
                        type="checkbox"
                        className="form-check-input cursor-pointer"
                        {...register('uso_limitado')}
                    />
                    <label
                        htmlFor="uso_limitado"
                        className="form-check-label cursor-pointer"
                        style={{ paddingLeft: '20px' }}
                    >
                        Uso limitado
                    </label>
                </div>
                <div className="row g-3 mb-3">
                    <div className="col-12 col-md-3">
                        <label htmlFor="codigo">Código</label>
                        <input
                            id="codigo"
                            type="text"
                            className="form-control"
                            {...register('codigo', {
                                required: 'El código es obligatorio',
                            })}
                        />

                        <div className="form-invalid">
                            {errors.codigo && errors.codigo.message}
                        </div>
                    </div>
                    <div className="col-12 col-md-3">
                        <label htmlFor="descuento">% Descuento</label>
                        <input
                            id="descuento"
                            type="number"
                            className="form-control"
                            {...register('descuento', {
                                required: 'El descuento es obligatorio',
                            })}
                        />

                        <div className="form-invalid">
                            {errors.descuento && errors.descuento.message}
                        </div>
                    </div>
                    <div className="col-12 col-md-3">
                        <label htmlFor="importe_maximo">Importe máximo</label>
                        <input
                            id="importe_maximo"
                            type="number"
                            className="form-control"
                            {...register('importe_maximo')}
                        />
                    </div>
                    <div className="col-12 col-md-3">
                        <label htmlFor="descuento">Caducidad</label>
                        <input
                            id="caducidad"
                            type="date"
                            className="form-control"
                            {...register('caducidad')}
                        />
                    </div>
                </div>
                <div className="form-group flex-grow-1">
                    <label htmlFor="subject">Email subject</label>
                    <input
                        id="subject"
                        type="text"
                        className="form-control"
                        {...register('subject', {
                            required: 'El subject del email es obligatorio',
                        })}
                    />

                    <div className="form-invalid">
                        {errors.subject && errors.subject.message}
                    </div>
                </div>
                <div className="form-group flex-grow-1">
                    <label htmlFor="texto">Email texto</label>
                    <textarea
                        id="texto"
                        className="form-control"
                        {...register('texto', {
                            required: 'El texto del email es obligatorio',
                        })}
                    />

                    <div className="form-invalid">
                        {errors.texto && errors.texto.message}
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-end pt-2">
                    <button
                        type="button"
                        className="btn btn-default align-self-end"
                        onClick={handleCancel}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary align-self-end ms-3"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <CircularProgress color="inherit" size={22} />
                        ) : (
                            'Guardar'
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default DescuentosMasivosForm;
